import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getColor } from "utils/colors";

const getRows = (data, handleOpenMenu, finalizada) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        tipoResiduo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.tipoResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        descripcionResiduo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.descripcionResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        descripcionTratamiento: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.descripcionTratamiento || "Sin descripción"}
            </SoftTypography>
          </SoftBox>
        ),
        cantidadResiduo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.cantidadResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        unidadResiduo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.unidadResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        tipoTratamiento: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.tipoTratamiento || "Sin tipo"}
            </SoftTypography>
          </SoftBox>
        ),
        unidadTratamiento: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.unidadTratamiento || "Sin unidad"}
            </SoftTypography>
          </SoftBox>
        ),
        observacion: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.observacion || "Sin observación"}
            </SoftTypography>
          </SoftBox>
        ),
        accion: !finalizada ? (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: getColor("gobSecondary"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleOpenMenu(e, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ) : (
          <></>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "tipoResiduo", desc: "Tipo de Residuo", align: "center", noOrder: true },
  { name: "descripcionResiduo", desc: "Descripción del Residuo", align: "left", noOrder: true },
  { name: "descripcionTratamiento", desc: "Disposición", align: "left", noOrder: true },
  { name: "cantidadResiduo", desc: "Cantidad", align: "left", noOrder: true },
  { name: "unidadResiduo", desc: "Unidad", align: "left", noOrder: true },
  { name: "tipoTratamiento", desc: "Tipo de Tratamiento", align: "left", noOrder: true },
  { name: "unidadTratamiento", desc: "Unidad de Tratamiento", align: "left", noOrder: true },
  { name: "observacion", desc: "Observación", align: "left", noOrder: true },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
